import { Slide,Snackbar,Alert } from '@mui/material'
import React from 'react'
import {useAlert} from '../Context/AlertContext';
function AlertSnackbar() {
    const {alert,setAlert}=useAlert();
    const handleClose=(e,reason)=>{
        if(reason==='clickaway'){
            return ;
        }
        setAlert({
            open:false,
            message:'',
            type:''
        })    
    }
  return (
    <div>
        <Snackbar open={alert.open}
            autoHideDuration={3000} onClose={handleClose}  anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }} 
            >
            <Slide in={alert.open}>
                <Alert severity={alert.type}>
                    {alert.message}
                </Alert>
            </Slide>
        </Snackbar>
    </div>   
  )
}

export default AlertSnackbar;